export default __webpack_public_path__ + "static/FuturaBT-Bold-5654f60daa67ea03ebc5ed9cea8b94e3.woff2";